module.exports = __webpack_public_path__ + "static/media/route-highway.5585a2f8.svg";